<app-pageheader [Parent]="this">
</app-pageheader>
  
<app-datalistview [Columns]="Columns" [ShowMap]="true" ApiUrl="infrastructure/guidancelights/searches"
[AllowEdit]="true" EditUrl="/hardware/devices/guidancelights/:id" [StructureViewerLayers]="StructureViewerLayers" StructureViewerForType="GuidanceLightConfiguration">
    <app-filter-set>
        <div app-search-filter></div>
        <div app-search-button></div>
    </app-filter-set>
</app-datalistview>